import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UploadBotIcon, UploadThumb } from '../api/UploadApi'; 
import { toast } from 'react-toastify';

export const useUploadBotIcon = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ file }) => UploadBotIcon(file),
    onSuccess: (data) => {
      toast.success('Thay đổi Bot icon thành công!');
      queryClient.invalidateQueries({ queryKey: ['agent'] });
    },
    onError: () => {
      toast.error('Thay đổi Bot icon thất bại!');
    },
  });
};


export const useUploadThumb = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ file }) => UploadThumb(file),
    onSuccess: (data) => {
      toast.success('Thay đổi ảnh khởi động thành công!');
      queryClient.invalidateQueries({ queryKey: ['agent'] });
    },
    onError: () => {
      toast.error('Thay đổi ảnh khởi động thất bại!');
    },
  });
};
